import React, { useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import { AuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import { FiLogIn, FiLogOut } from "react-icons/fi";

const Header = () => {
  const { language, setLanguage, t } = useContext(LanguageContext);
  const { isAuthenticated, logout } = useContext(AuthContext);

  const handleLogout = () => {
    logout();
    localStorage.removeItem("token");
    window.dispatchEvent(new Event("storage"));
    window.location.href = "/";
  };

  return (
    <header className="flex justify-between items-center p-4 shadow bg-white">
      <Link to="/">
        <img src="/logo.png" alt="TeamCoin Logo" className="h-10" />
      </Link>

      <nav className="flex gap-4">
        <Link to="/">{t("Home")}</Link>
        <Link to="/clubs">{t("Clubs")}</Link>
        <Link to="/cms/faq">{t("faq")}</Link>        
        <Link to="/teamcoin-markt">{t("Market")}</Link>        
        {isAuthenticated && JSON.parse(localStorage.getItem("user"))?.role === "sponsor" && (
          <Link to="/sponsor/donations">{t("donations")}</Link>
        )}
      </nav>

      <div className="flex items-center gap-2">
        {/* Language Switch */}
        <button
          onClick={() => setLanguage("EN")}
          className={`text-xl hover:opacity-80 transition ${
            language === "EN" ? "opacity-100" : "opacity-50"
          }`}
          aria-label="English"
        >
          🇬🇧
        </button>
        <button
          onClick={() => setLanguage("DE")}
          className={`text-xl hover:opacity-80 transition ${
            language === "DE" ? "opacity-100" : "opacity-50"
          }`}
          aria-label="Deutsch"
        >
          🇩🇪
        </button>

        {isAuthenticated ? (
          <button
            onClick={handleLogout}
            className="ml-4 flex items-center gap-2 px-4 py-1 text-sm font-medium text-white bg-red-500 hover:bg-red-600 rounded-full transition"
          >
            <FiLogOut />
            {t("logout")}
          </button>
        ) : (
          <Link
            to="/login"
            className="ml-4 flex items-center gap-2 px-4 py-1 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-full transition"
          >
            <FiLogIn />
            {t("login")}
          </Link>
        )}
      </div>
    </header>
  );
};

export default Header;
